import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
let TagModel = (_dec = attr('string'), _dec2 = belongsTo('file', {
  inverse: null,
  async: false
}), _dec3 = attr('boolean', {
  defaultValue: false
}), _class = class TagModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "value", _descriptor, this);
    _initializerDefineProperty(this, "file", _descriptor2, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "file", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { TagModel as default };
//# sourceMappingURL=tag.js.map
